<!-- Web component Wacom -->
<wacom-signature *ngIf="isFegMode" 
  #wacomSignature
  [attr.allow-mouse]="''"
  [attr.allow-touch]="''"
  [attr.patient-name]="signer"
  document-hash=""
  document-size=""
  hash-algorithm="SHA512"
  tag-name="GRAFOMETRICA"
  public-key=""
  style="display:none">
</wacom-signature>

<div class="p-d-flex p-jc-center info-signature" *ngIf="operator || clinic || signer">
    <span class="info-signature-item" *ngIf="operator">
        <span class="info-signature-item-icon">
            <i class="pi pi-user"></i>
        </span>
        <span class="info-signature-item-text">{{operator}}</span>
    </span>
    <span class="info-signature-item" *ngIf="clinic">
        <span class="info-signature-item-icon">
            <i class="pi pi-home"></i>
        </span>
        <span class="info-signature-item-text">{{clinic}}</span>
    </span>
    <span class="info-signature-item" *ngIf="signer">
        <span class="info-signature-item-icon">
            <i class="pi pi-pencil"></i>
        </span>
        <span class="info-signature-item-text"><b>{{signer}}</b></span>
    </span>
</div>
<div *ngIf="documentHasMetadata && !isMobile()" class="p-grid" [style]="{width: '100%', height: customHeight, background: '#fff'}">
    <div class="p-col-10 viewer-pdf-wrapper">
        <ngx-extended-pdf-viewer [hidden]="!pdfDocBase64 && convertToNumber()<0" [base64Src]="pdfDocBase64" backgroundColor="#edf1f5" [height]="customReaderHeight"
            [useBrowserLocale]="false" [language]="languageSelected" [handTool]="false" [showHandToolButton]="false"
            [enableScripting]="false" [enableForms]="false" [enableAnnotations]="false"
            [disableAutoFetch]="true" [disableRange]="true" [disableStream]="true"
            *ngIf="pdfDocBase64">
        </ngx-extended-pdf-viewer>
    </div>
    <div class="p-col-2 viewer-metadata-wrapper">
        <div (window:resize)="setHeightPanelMetadata()">
            <form [formGroup]="formMetadata" (ngSubmit)="onSubmitFormMetadata()" class="form-metadata" novalidate>
                <div class="p-grid oris-p-grid">
                    <div class="p-col-12 p-d-flex p-ai-center p-jc-center metadata-container-inner">
                        <div class="p-d-flex p-jc-center metadata-header"
                            [innerHTML]="'documentSign.additionalInformation' | translate"></div>
                        <div class="p-fluid metadata-container-input">
                            <div class="text-container metadata-description">{{'documentSign.fillAdditionalDataBeforeSign' | translate}}</div>
                            <p-divider></p-divider>
                            <p-scrollPanel [style]="{width: '100%', height: heightPanelMetadata}" styleClass="form-p-mb-2">
                                <ng-container *ngFor="let metadata of signMetadataFormatted">
                                    <ng-container [ngSwitch]="metadata.metadataType">
                                        <div *ngSwitchCase="'TEXT'">
                                            <div class="text-container">
                                                <ng-container class="p-mb-2">
                                                    <div class="p-field">
                                                        <label [attr.for]="metadata.key" *ngIf="metadata.label">
                                                            {{metadata.label}}
                                                            <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                        </label>
                                                        <div class="p-inputgroup">
                                                            <input pInputText [formControlName]="metadata.key"
                                                                [id]="metadata.key" [type]="metadata.metadataType"
                                                                [placeholder]="metadata.label"
                                                                (change)="inputValueTrimmed(metadata.key);"
                                                                [readonly]="disabledInputMetadata"
                                                                [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''">
                                                            <button pButton pRipple type="button" icon="pi pi-search"
                                                                class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                                (click)="metadataPaginateSignature(metadata.tag)"></button>
                                                        </div>
                                                        <small class="p-error block"
                                                            *ngIf="metadataFieldIsValid(metadata.key)">{{'documentSign.requiredField' | translate}}
                                                        </small>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div *ngSwitchCase="'DROPDOWN'">
                                            <div class="dropdown-container">
                                                <ng-container>
                                                    <div class="p-field">
                                                        <label [attr.for]="metadata.key" *ngIf="metadata.label">
                                                            {{metadata.label}}
                                                            <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                        </label>
                                                        <div class="p-inputgroup p-mb-2">
                                                            <p-dropdown appendTo="body" class="oris-dropdown"
                                                                [options]="metadata.acceptedValues"
                                                                [readonly]="disabledInputMetadata" [id]="metadata.key"
                                                                [formControlName]="metadata.key"
                                                                placeholder="{{'documentSign.select' | translate}}"
                                                                [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''">
                                                            </p-dropdown>
                                                            <button pButton pRipple type="button" icon="pi pi-search"
                                                                class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                                (click)="metadataPaginateSignature(metadata.tag)"></button>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div *ngSwitchCase="'CHECKBOX'">
                                            <div class="checkbox-container">
                                                <ng-container>
                                                    <div class="p-field">
                                                        <label *ngIf="metadata.label">
                                                            {{metadata.label}}
                                                            <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                        </label>
                                                    </div>
                                                    <div class="p-field-checkbox" *ngFor="let checkboxItem of metadata.items">
                                                        <p-checkbox name="{{metadata.groupName}}"
                                                            value="{{checkboxItem.acceptedValues[0]}}"
                                                            inputId="{{checkboxItem.metadataID}}"
                                                            [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''"
                                                            (onChange)="handleMetadataCheckbox($event, metadata.key, checkboxItem.acceptedValues[0]);"
                                                            [disabled]="disabledInputMetadata">
                                                        </p-checkbox>
                                                        <label
                                                            [attr.for]="checkboxItem.metadataID">{{checkboxItem.acceptedValues[0]}}</label>
                                                        <button pButton pRipple type="button" icon="pi pi-search"
                                                            class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                            (click)="metadataPaginateSignature(checkboxItem.tag)"></button>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div *ngSwitchCase="'RADIO'">
                                            <div class="radio-container">
                                                <ng-container>
                                                    <div class="p-field">
                                                        <label *ngIf="metadata.label">
                                                            {{metadata.label}}
                                                            <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                        </label>
                                                    </div>
                                                    <div class="p-field-radiobutton" *ngFor="let radioItem of metadata.items">
                                                        <p-radioButton name="{{metadata.groupName}}"
                                                            value="{{radioItem.acceptedValues[0]}}"
                                                            inputId="{{radioItem.metadataID}}" [formControlName]="metadata.key"
                                                            [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''"
                                                            [ngModelOptions]="{standalone: true}"
                                                            [disabled]="disabledInputMetadata"></p-radioButton>
                                                        <label
                                                            [attr.for]="radioItem.metadataID">{{radioItem.acceptedValues[0]}}</label>
                                                        <button pButton pRipple type="button" icon="pi pi-search"
                                                            class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                            (click)="metadataPaginateSignature(radioItem.tag)"></button>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </p-scrollPanel>
                        </div>
                        <div>
                            <button pButton label="{{'documentSign.clear' | translate}}" icon="pi pi-times" type="button"
                                class="p-button-danger p-mr-2" [disabled]="disabledBtnClearMetadata"
                                (click)="clearMetadataTags()"></button>
                            <button pButton label="{{'documentSign.apply' | translate}}" icon="pi pi-check" type="submit"
                                class="p-button-success" [disabled]="formMetadata.invalid || disabledBtnApplyMetadata"></button>
                        </div>
                        <small class="p-error form-msg-error" *ngIf="formMetadata.invalid">
                            {{'documentSign.fillRequiredFields' | translate}}
                        </small>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div *ngIf="(pdfDocBase64 && !documentHasMetadata) || (pdfDocBase64 && documentHasMetadata && isMobile())"
[style]="{width: '100%', height: '60vh', background: '#fff'}">
    <ngx-extended-pdf-viewer [hidden]="!pdfDocBase64 && convertToNumber()<0" [base64Src]="pdfDocBase64" backgroundColor="#edf1f5" [height]="customReaderHeight"
        [useBrowserLocale]="false" [language]="languageSelected" [handTool]="false" [showHandToolButton]="false"
        [enableScripting]="false" [enableForms]="false" [enableAnnotations]="false"
        [disableAutoFetch]="true" [disableRange]="true" [disableStream]="true"
        [showUnverifiedSignatures]="true">
    </ngx-extended-pdf-viewer>
</div>





<div class="p-d-flex p-jc-center recap-signatures" *ngIf="totalSignatures > 0"
    [innerHTML]="'documentSign.recapSignatures' | translate:{'numberSignaturesDone': numberSignaturesDone, 'totalSignatures': totalSignatures}">
</div>
<ng-container *ngIf="totalSignatures > 0 && !isMobile()">
    <div class="p-d-flex p-jc-center p-mt-0">
        <div class="p-alert-description">
            <small class="p-error form-msg-error" style="margin-top: 0px !important" *ngIf="documentHasMetadata && disabledBtnSign">{{'documentSign.fillRequiredFieldsToSignDocument' | translate}}</small>        </div>
    </div>
    <div class="p-d-flex p-jc-center p-align-center p-mt-3 p-mb-5 paginatorBlock">
        <p-paginator #paginator [rows]="1" [totalRecords]="totalSignatures" (onPageChange)="paginateSignature($event)">
        </p-paginator>
        <p-button class="min-w-10" (click)="showDialogSign(feaTotalSignatures > 1 && !isMobile())" icon="pi pi-pencil"
            label="{{'documentSign.buttonSign' | translate}}" [(disabled)]="disabledBtnSign"></p-button>
        <!-- <p-button *ngIf="feaTotalSignatures > 1 && !isMobile()" class="min-w-10" (click)="showDialogSign(true)" icon="pi pi-pencil"
            label="{{'documentSign.buttonSignAll' | translate}}" [(disabled)]="disabledBtnSign"></p-button> -->
        <p-button *ngIf="showButtonConfirmSign" class="min-w-10" (click)="confirmCompleteSignatures()" icon="pi pi-check"
            label="{{'documentSign.buttonConfirmSign' | translate}}" [(disabled)]="disabledBtnConfirm"></p-button>
        <button pButton class="btn-cancel" (click)="goBack()" icon="pi pi-arrow-left" label="{{'backButton' | translate}}"
            [(disabled)]="disabledBtnGoBack"></button>
    </div>
</ng-container>
<div class="p-col-12 mobile-actions-signature paginatorBlock" *ngIf="totalSignatures > 0 && isMobile()">
    <p-paginator #paginatorMobile [rows]="1" [totalRecords]="totalSignatures" (onPageChange)="paginateSignature($event)"></p-paginator>
    <ng-container *ngIf="documentHasMetadata">
        <div class="p-d-flex p-jc-center p-mt-0">
            <div class="p-alert-description">
                <small class="p-error form-msg-error" style="margin-top: 0px !important" *ngIf="formMetadata.invalid || disabledBtnSign">{{'documentSign.fillRequiredFieldsToSignDocument' | translate}}</small>
            </div>
        </div>
        <div class="p-d-flex p-jc-center p-align-center">
            <div class="p-d-flex p-jc-center p-align-center p-mt-2">
                <p-button class="button-mobile-action" (click)="openMetadataSidebar()" icon="pi pi-list"
                    label="{{'documentSign.buttonMetadata' | translate}}" [disabled]="disabledBtnApplyMetadata"></p-button>
            </div>
            <div class="p-d-flex p-jc-center p-align-center p-mt-2">
                <p-button class="button-mobile-action" (click)="showDialogSign(feaTotalSignatures > 1 && isMobile())" icon="pi pi-pencil"
                    label="{{'documentSign.buttonSign' | translate}}" [(disabled)]="disabledBtnSign"></p-button>
                <!-- <p-button *ngIf="feaTotalSignatures > 1 && isMobile()" class="min-w-10" (click)="showDialogSign(true)" icon="pi pi-pencil"
                    label="{{'documentSign.buttonSignAll' | translate}}" [(disabled)]="disabledBtnSign"></p-button>  -->
            </div>
        </div>
        <div class="p-d-flex p-jc-center p-mt-2">
            <p-button *ngIf="showButtonConfirmSign" class="button-mobile-action" (click)="confirmCompleteSignatures()" icon="pi pi-check"
                label="{{'documentSign.buttonConfirmSign' | translate}}" [(disabled)]="disabledBtnConfirm"></p-button>
            <button pButton class="btn-cancel button-mobile-action" (click)="goBack()" icon="pi pi-arrow-left"
                label="{{'backButton' | translate}}" [(disabled)]="disabledBtnGoBack"></button>
        </div>
    </ng-container>
    <ng-container *ngIf="!documentHasMetadata">
        <div class="p-d-flex p-jc-center p-align-center p-mt-1">
            <p-button class="button-mobile-action" (click)="showDialogSign(!documentHasMetadata && feaTotalSignatures > 0)" icon="pi pi-pencil"
                label="{{'documentSign.buttonSign' | translate}}" [(disabled)]="disabledBtnSign"></p-button>
            <!-- <p-button *ngIf="!documentHasMetadata && feaTotalSignatures > 0" class="min-w-10" (click)="showDialogSign(true)" icon="pi pi-pencil"
                label="{{'documentSign.buttonSignAll' | translate}}" [(disabled)]="disabledBtnSign"></p-button> -->
            <p-button *ngIf="showButtonConfirmSign" class="min-w-10" (click)="confirmCompleteSignatures()" icon="pi pi-check"
                label="{{'documentSign.buttonConfirmSign' | translate}}" [(disabled)]="disabledBtnConfirm"></p-button>
        </div>
        <div class="p-d-flex p-jc-center p-mt-2">
            <button pButton class="btn-cancel" (click)="goBack()" icon="pi pi-arrow-left" label="{{'backButton' | translate}}"
                [(disabled)]="disabledBtnGoBack"></button>
        </div>
    </ng-container>
</div>
<p-dialog (onHide)="closeDialogSign(false, true)" header="{{'documentSign.titleChoiceSignFes' | translate}}"
    [(visible)]="displayModalFesSign" [modal]="true" [breakpoints]="{'960px': '80vw', '560px': '90vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div *ngFor="let fesSign of fesSignTypes" class="p-field-checkbox">
        <p-radioButton [inputId]="fesSign.value" name="fesSignType" [value]="fesSign" [(ngModel)]="selectedFesSygnType"
            (onClick)="setFesSygnType($event);"></p-radioButton>
        <label [for]="fesSign.value" *ngIf="fesSign.value == 'click_sign'">{{'documentSign.click_sign' | translate}}</label>
        <label [for]="fesSign.value" *ngIf="fesSign.value == 'graph_sign'">{{'documentSign.graph_sign' | translate}}</label>
    </div>
    <div class="signature-pad">
        <div class="signature-pad--body">
            <canvas #sPad (click)="clearMessages()"></canvas>
        </div>
    </div>
    <p-messages></p-messages>
    <button pButton pRipple type="button" (click)="clearSignaturePad()" label="{{'documentSign.clear' | translate}}"
        class="p-button-danger p-mt-3"></button>
    <ng-template pTemplate="footer">
        <button pButton icon="pi pi-times" (click)="closeDialogSign(false, true)"
            label="{{'documentSign.cancel' | translate}}" class="btn-dialog-cancel btn-cancel"></button>
        <button pButton icon="pi pi-check" (click)="confirmFesSign()"
            label="{{'documentSign.confirmSign' | translate}}"></button>
    </ng-template>
</p-dialog>
<p-dialog (onHide)="closeDialogSign(false, true)" header="{{'documentSign.titleConfirmPrivacy' | translate}}"
    [(visible)]="displayModalPrivacySign" [modal]="true" [breakpoints]="{'960px': '80vw', '560px': '90vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="p-fluid">
        <div class="p-formgroup-inline">
            <div class="p-col-12">
                <div class="p-field">
                    <p>
                        {{'documentSign.messagePrivacy' | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <p-messages></p-messages>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="confirmPrivacy(true)"
            label="{{'documentSign.yesPrivacyButton' | translate}}"></p-button>
        <button pButton class="btn-cancel" icon="pi pi-times" (click)="confirmPrivacy(false)"
            label="{{'documentSign.noPrivacyButton' | translate}}"></button>

    </ng-template>
</p-dialog>
<div *ngIf="documentHasMetadata && isMobile()" class="metadata-sidebar-overlay" [style]="{visibility: visibleMetadataSidebar ? 'visible' : 'hidden'}"></div>
<p-sidebar *ngIf="documentHasMetadata && isMobile()" [modal]="false" [(visible)]="visibleMetadataSidebar" appendTo="body" position="right" [baseZIndex]="10010" [style]="{width: '290px', borderRadius: '0px'}">
    <form [formGroup]="formMetadata" (ngSubmit)="closeMetadataSidebar();onSubmitFormMetadata();" class="form-metadata" novalidate>
        <div class="p-grid oris-p-grid">
            <div class="p-col-12 p-d-flex p-ai-center p-jc-center metadata-container-inner">
                <div class="p-d-flex p-jc-center metadata-header" [innerHTML]="'documentSign.additionalInformation' | translate"></div>
                <div class="p-fluid sidebar-metadata-container-input" [style]="{padding: '2rem 0.75rem'}">
                    <div class="text-container metadata-description">{{'documentSign.fillAdditionalDataBeforeSign' | translate}}</div>
                    <p-divider></p-divider>
                    <p-scrollPanel [style]="{width: '100%', height: mobileHeightPanelMetadata}" styleClass="form-p-mb-2">
                        <ng-container *ngFor="let metadata of signMetadataFormatted">
                            <ng-container [ngSwitch]="metadata.metadataType">
                                <div *ngSwitchCase="'TEXT'">
                                    <div class="text-container">
                                        <ng-container class="p-mb-2">
                                            <div class="p-field">
                                                <label [attr.for]="metadata.key" *ngIf="metadata.label">
                                                    {{metadata.label}}
                                                    <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                </label>
                                                <div class="p-inputgroup">
                                                    <input pInputText [formControlName]="metadata.key" [id]="metadata.key"
                                                        [type]="metadata.metadataType" [placeholder]="metadata.label"
                                                        (change)="inputValueTrimmed(metadata.key);"
                                                        [readonly]="disabledInputMetadata"
                                                        [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''">
                                                    <button pButton pRipple type="button" icon="pi pi-search"
                                                        class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                        (click)="metadataPaginateSignature(metadata.tag);closeMetadataSidebar();"></button>
                                                </div>
                                                <small class="p-error block"
                                                    *ngIf="metadataFieldIsValid(metadata.key)">{{'documentSign.requiredField' | translate}}</small>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div *ngSwitchCase="'DROPDOWN'">
                                    <div class="dropdown-container">
                                        <ng-container>
                                            <div class="p-field">
                                                <label [attr.for]="metadata.key" *ngIf="metadata.label">
                                                    {{metadata.label}}
                                                    <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                </label>
                                                <div class="p-inputgroup p-mb-2">
                                                    <p-dropdown class="oris-dropdown"
                                                        [options]="metadata.acceptedValues"
                                                        [readonly]="disabledInputMetadata" [id]="metadata.key"
                                                        [formControlName]="metadata.key"
                                                        placeholder="{{'documentSign.select' | translate}}"
                                                        [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''">
                                                    </p-dropdown>
                                                    <button pButton pRipple type="button" icon="pi pi-search"
                                                        class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                        (click)="metadataPaginateSignature(metadata.tag);closeMetadataSidebar();"></button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div *ngSwitchCase="'CHECKBOX'">
                                    <div class="checkbox-container">
                                        <ng-container>
                                            <div class="p-field">
                                                <label *ngIf="metadata.label">
                                                    {{metadata.label}}
                                                    <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                </label>
                                            </div>
                                            <div class="p-field-checkbox" *ngFor="let checkboxItem of metadata.items">
                                                <p-checkbox name="{{metadata.groupName}}"
                                                    value="{{checkboxItem.acceptedValues[0]}}"
                                                    inputId="{{checkboxItem.metadataID}}"
                                                    [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''"
                                                    (onChange)="handleMetadataCheckbox($event, metadata.key, checkboxItem.acceptedValues[0]);"
                                                    [disabled]="disabledInputMetadata">
                                                </p-checkbox>
                                                <label
                                                    [attr.for]="checkboxItem.metadataID">{{checkboxItem.acceptedValues[0]}}</label>
                                                <button pButton pRipple type="button" icon="pi pi-search"
                                                    class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                    (click)="metadataPaginateSignature(checkboxItem.tag);closeMetadataSidebar();"></button>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                                <div *ngSwitchCase="'RADIO'">
                                    <div class="radio-container">
                                        <ng-container>
                                            <div class="p-field">
                                                <label *ngIf="metadata.label">
                                                    {{metadata.label}}
                                                    <span *ngIf="metadata.isRequired" class="required-field">*</span>
                                                </label>
                                            </div>
                                            <div class="p-field-radiobutton" *ngFor="let radioItem of metadata.items">
                                                <p-radioButton name="{{metadata.groupName}}"
                                                    value="{{radioItem.acceptedValues[0]}}"
                                                    inputId="{{radioItem.metadataID}}" [formControlName]="metadata.key"
                                                    [ngClass]="metadataFieldIsValid(metadata.key) ? 'ng-invalid ng-dirty' : ''"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [disabled]="disabledInputMetadata"></p-radioButton>
                                                <label
                                                    [attr.for]="radioItem.metadataID">{{radioItem.acceptedValues[0]}}</label>
                                                <button pButton pRipple type="button" icon="pi pi-search"
                                                    class="p-button-sm p-button-rounded p-button-help p-button-text"
                                                    (click)="metadataPaginateSignature(radioItem.tag);closeMetadataSidebar();"></button>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </p-scrollPanel>
                </div>
                <div>
                    <button pButton label="{{'documentSign.clear' | translate}}" icon="pi pi-times" type="button"
                        class="p-button-danger p-mr-2" [disabled]="disabledBtnClearMetadata"
                        (click)="clearMetadataTags()"></button>
                    <button pButton label="{{'documentSign.apply' | translate}}" icon="pi pi-check" type="submit"
                        class="p-button-success" [disabled]="formMetadata.invalid || disabledBtnApplyMetadata"></button>
                </div>
                <small class="p-error form-msg-error" *ngIf="formMetadata.invalid">{{'documentSign.fillRequiredFields' | translate}}</small>
            </div>
        </div>
    </form>
</p-sidebar>



<p-confirmDialog [breakpoints]="{'960px': '80vw', '560px': '90vw'}" [style]="{width: '50vw'}" [baseZIndex]="10000">
</p-confirmDialog>

<p-dialog (onHide)="closeDialogSign(false, false)" header="{{'documentSign.titleConfirmSignFea' | translate}}"
    [(visible)]="displayModalFeaSign" [modal]="true" [breakpoints]="{'960px': '80vw', '560px': '90vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="p-fluid">
        <div class="p-formgroup-inline space-formgroup">
            <div class="p-col-12">
                <p>
                    {{ 'documentSign.messageOtpSent' | translate:{'confirmTxtOtpSent': confirmTxtOtpSent} }}
                </p>
            </div>
            <div class="p-col-6">
                <div class="p-field">
                    <label for="otpcode-sign">{{ 'documentSign.labelInputOtpCode' | translate }}</label>
                    <input type="text" id="otpcode-sign" class="p-inputtext-lg" pInputText [(ngModel)]="otpCodeInput">
                </div>
            </div>
        </div>
    </div>
    <p-messages></p-messages>
    <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-end">
            <div class="timer-resend-otp p-mr-2">{{timerBtnResendOtp}}</div>
            <p-button icon="pi pi-send" (click)="resendOtp()" label="{{'documentSign.buttonResendOtp' | translate}}"
                class="p-button-text" [(disabled)]="disabledBtnResendOtp"></p-button>
            <p-button icon="pi pi-check" (click)="confirmFeaSign()" label="{{'documentSign.confirm' | translate}}">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<p-dialog [closable]="false" [(visible)]="displayModalAlreadySigned" [modal]="true"
    [breakpoints]="{'960px': '70vw', '560px': '90vw'}" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <p-header class="title-already-signed">{{ 'documentSign.titleDocumentAlreadySigned' | translate }}</p-header>
    <p class="message-already-signed">{{ 'documentSign.messageDocumentAlreadySigned' | translate }}</p>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<p-dialog [closable]="false" [(visible)]="displayModalDocumentExpired" [modal]="true"
    [breakpoints]="{'960px': '70vw', '560px': '90vw'}" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <p-header class="title-already-signed">{{ 'documentSign.titleDocumentExpired' | translate }}</p-header>
    <p class="message-already-signed">{{ 'documentSign.messageDocumentExpired' | translate }}</p>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>
<canvas #cSign id="template-sign-canvass" width="536" height="80"></canvas>
<canvas #cSignX id="template-check-canvass" width="20" height="20"></canvas>
<canvas #cMetadata id="template-metadata-canvass" width="750" height="150"></canvas>
<div class="loading-indicator" *ngIf="(activeLoader === true) && (activeLoaderConfirmSignature === false)">
    <p-progressSpinner styleClass="custom-spinner" strokeWidth="6" fill="#EEEEEE" animationDuration="1.5s">
    </p-progressSpinner>
</div>
<div class="loading-indicator" *ngIf="(activeLoaderConfirmSignature === true) && (activeLoader === false)">
    <p-progressSpinner styleClass="custom-spinner" strokeWidth="6" fill="#EEEEEE" animationDuration="1.5s">
    </p-progressSpinner>
</div>



<div class="oris-layout layout-main-content">
    <router-outlet></router-outlet>
    <p-dialog [closable]="false" [(visible)]="displayModalError" [modal]="true" [breakpoints]="{'960px': '70vw', '560px': '90vw'}" [style]="{width: '50vw'}" [baseZIndex]="10000"
        [draggable]="false" [resizable]="false">
        <p-header class="title-already-signed">{{ messageTitle | translate }}</p-header>
        <p class="message-already-signed">{{ messageDetail | translate }}</p>
        <p *ngIf="oauthMessage != ''" class="message-already-signed">{{ retryLater | translate }}</p>
        <ng-template pTemplate="footer">
            <p-button (click)="closeModal()" label="{{'documentSign.okButton' | translate}}" class="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>

<!-- Dialog per errori di autenticazione -->
<p-dialog
    [closable]="false"
    [(visible)]="displayAuthError"
    [modal]="true"
    [breakpoints]="{'960px': '70vw', '560px': '90vw'}"
    [style]="{width: '50vw'}"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false">
    <p-header class="title-already-signed">{{ 'documentSign.authErrorTitle' | translate }}</p-header>
    <p class="message-already-signed">{{ 'documentSign.authErrorHint' | translate }}</p>
    <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-center p-ai-center">
            <div *ngIf="canRetryAuth && timerBtnRetryAuth" class="timer-retry-auth p-mr-2">{{ 'documentSign.retryWait' | translate }} {{timerBtnRetryAuth}}</div>
            <p-button
                *ngIf="canRetryAuth"
                (click)="retryAfterAuthError()"
                label="{{'documentSign.retryButton' | translate}}"
                icon="pi pi-refresh"
                styleClass="p-button-primary p-mr-2"
                [disabled]="disabledBtnRetryAuth">
            </p-button>
            <p-button
                (click)="dismissAuthError()"
                [label]="canRetryAuth ? ('documentSign.cancel' | translate) : ('documentSign.okButton' | translate)"
                styleClass="p-button-text">
            </p-button>
        </div>
    </ng-template>
</p-dialog>
